import { axios } from '@/utils/request'

export function getCorp (id) {
  return axios({
    url: '/corp/' + id,
    method: 'get'
  })
}

export function pageCorp (query) {
  return axios({
    url: '/corps',
    method: 'get',
    params: query
  })
}

export function createCorp (form) {
  return axios({
    url: '/corp',
    method: 'post',
    data: form
  })
}

export function updateCorp (id, form) {
  return axios({
    url: '/corp/' + id,
    method: 'put',
    data: form
  })
}

export function deleteCorp (id) {
  return axios({
    url: '/corp/' + id,
    method: 'delete'
  })
}
